import axios from 'axios';

/**
 * Universal Email API handler
 * Sends form data to AWS Lambda function via API Gateway
 */
const LAMBDA_API_URL = process.env.REACT_APP_LAMBDA_EMAIL_API;

/**
 * Submit form data to Lambda email handler
 * @param {string} formName - Name of the form (e.g., 'contact', 'careers', 'bundle_inquiry')
 * @param {object} formData - Form data object
 * @returns {Promise} - Axios promise
 */
export const submitFormToLambda = async (formName, formData) => {
  try {
    const response = await axios.post(LAMBDA_API_URL, {
      formName,
      formData
    }, {
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 10000 // 10 seconds timeout
    });
    
    return response.data;
  } catch (error) {
    console.error('Error submitting form:', error);
    
    // Provide more specific error messages
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timeout. Please try again.');
    } else if (error.response) {
      // Server responded with error status
      throw new Error(error.response.data.message || 'Failed to submit form. Please try again.');
    } else if (error.request) {
      // Request made but no response
      throw new Error('Network error. Please check your connection and try again.');
    } else {
      throw new Error('An unexpected error occurred. Please try again.');
    }
  }
};

/**
 * Validate email format
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validate phone number (Indian format)
 * @param {string} phone - Phone number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validatePhone = (phone) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
};
